import axios from 'axios';
import { axiosInstance } from "../utils/axios-instance";

export const fetchData = async (query, options = {}) => {
  try {
    // Merge default options with provided options
    const config = {
      ...options,
      // Ensure we don't override important options
      validateStatus: (status) => status < 500, // Accept any status code less than 500
    };

    const response = await axiosInstance.get(query, config);
    
    // Handle non-2xx status codes that we want to treat as success
    if (response.status >= 400) {
      console.warn(`API returned status ${response.status} for ${query}`);
      return null;
    }

    return response;
  } catch (error) {
    if (axios.isCancel(error)) {
      console.log("Request canceled:", error.message);
      return null; // Return null for cancelled requests instead of throwing
    } else if (error.response) {
      // Server responded with error status
      console.error("Server error:", error.response.status, error.response.data);
      return null;
    } else if (error.request) {
      // Network error
      console.error("Network error:", error.message);
      return null;
    } else {
      // Something else happened
      console.error("Request error:", error.message);
      return null;
    }
  }
};

// Batch fetch function for multiple concurrent requests
export const fetchMultipleData = async (requests) => {
  const promises = requests.map(({ query, options = {} }) => 
    fetchData(query, options).then(response => ({ query, response, error: null }))
      .catch(error => ({ query, response: null, error }))
  );

  return Promise.allSettled(promises);
};